import { Directive } from '@angular/core';

@Directive({
    selector: 'li[wdxTab]',
    standalone: false,
    host: { class: 'nav-item pointer' },
})
export class WdxTabDirective {}
